// src/components/ui/HamburgerButton.jsx
import React from 'react';
import '../../styles/hamburger-menu.css';

const HamburgerButton = ({ isOpen, onClick, className = '' }) => {
  return (
    <button
      className={`hamburger-button ${className}`}
      onClick={onClick}
      aria-label={isOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
      aria-expanded={isOpen}
    >
      <div className={`hamburger-icon ${isOpen ? 'open' : ''}`}>
        <span className="hamburger-bar"></span>
        <span className="hamburger-bar"></span>
        <span className="hamburger-bar"></span>
      </div>
    </button>
  );
};

export default HamburgerButton;